import MatchEvent from 'interfaces/matchEvent';
import { MatchSliceState } from '../matchSliceTypes';
import isGoalEvent from './isGoalEvent';
import { MatchStatus } from '../../../enums/matchStatus';
import { MatchEventType } from '../../../enums/matchEventType';

export default function (state: MatchSliceState, matchEvent: MatchEvent): void {
  const { homeTeam, awayTeam, matchStatusId } = state.match;

  if (isGoalEvent(matchEvent)) {
    if (!matchEvent.team) {
      throw 'No team attached to goal matchEvent (1)';
    }
    if (state.match.result) {
      if ([MatchStatus.FIRST_HALF, MatchStatus.HALF_TIME, MatchStatus.SECOND_HALF].includes(matchStatusId)) {
        if (matchEvent.team.id === homeTeam.id) {
          state.match.result.homeScore90 = state.match.result.homeScore90 + 1;
        }
        if (matchEvent.team.id === awayTeam.id) {
          state.match.result.awayScore90 = state.match.result.awayScore90 + 1;
        }
      } else if (
        [
          MatchStatus.FIRST_HALF_EXTRA_TIME,
          MatchStatus.HALF_TIME_EXTRA_TIME,
          MatchStatus.SECOND_HALF_EXTRA_TIME,
        ].includes(matchStatusId)
      ) {
        if (matchEvent.team.id === homeTeam.id) {
          state.match.result.homeScore120 = state.match.result.homeScore120 + 1;
        }
        if (matchEvent.team.id === awayTeam.id) {
          state.match.result.awayScore120 = state.match.result.awayScore120 + 1;
        }
      }
    }
  } else if (MatchStatus.PENALTIES === matchStatusId && matchEvent.matchEventTypeId === MatchEventType.PENALTIES_GOAL) {
    if (!matchEvent.team) {
      throw 'No team attached to goal matchEvent (3)';
    }
    if (state.match.result) {
      if (matchEvent.team.id === homeTeam.id) {
        state.match.result.homeScorePenalties = state.match.result.homeScorePenalties + 1;
      }
      if (matchEvent.team.id === awayTeam.id) {
        state.match.result.awayScorePenalties = state.match.result.awayScorePenalties + 1;
      }
    }
  }
}
